import React, { useState } from "react";
import { Row, Col, Container, Form, Button, Image, Modal } from 'react-bootstrap'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'

//img
import logo from '../../../assets/images/logo.png'
import authBackground from '../../../assets/images/login/loginoage background 1.png'

import { ToastProvider, useToasts } from 'react-toast-notifications';
import Swal from 'sweetalert2'
import { apiHandler } from '../../../api/apihandler';
import { REGISTER_PARENT } from "../../../api/constants";
import { Icon } from 'react-icons-kit';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { eye } from 'react-icons-kit/feather/eye'

const base64Decode = (encoded) => {
   if (!encoded) return '';
   try {
      return atob(encoded);
   } catch (error) {
      console.error('Invalid Base64 string:', error);
      return '';
   }
};

const ParentSignUp = () => {
   const navigate = useNavigate();
   const { addToast } = useToasts();
   const [searchParams] = useSearchParams();

   const [firstName, setFirstName] = useState('')
   const [lastName, setLastName] = useState('')
   const [email, setEmail] = useState(base64Decode(searchParams.get('email')))
   const [password, setPassword] = useState('')
   const [confirmPass, setConfirmPass] = useState('')
   const [pType, setPType] = useState('password');
   const [pIcon, setPIcon] = useState(eyeOff);
   const [cpType, setCPType] = useState('password');
   const [cpIcon, setCPIcon] = useState(eyeOff);
   const [isSubmitting, setIsSubmitting] = useState(false);

   const studentId = base64Decode(searchParams.get('student_id'));
   const token = searchParams.get('token') || '';
   const isParentRegistered = searchParams.get('is_parent_registered') === 'true';

   const [linkPassword, setLinkPassword] = useState('');
   const [linkPType, setLinkPType] = useState('password');
   const [linkPIcon, setLinkPIcon] = useState(eyeOff);
   const [isLinking, setIsLinking] = useState(false);

   const handleLinkPToggle = () => {
      if (linkPType === 'password') {
         setLinkPIcon(eye);
         setLinkPType('text')
      } else {
         setLinkPIcon(eyeOff)
         setLinkPType('password')
      }
   }

   const handlePToggle = () => {
      if (pType === 'password') {
         setPIcon(eye);
         setPType('text')
      } else {
         setPIcon(eyeOff)
         setPType('password')
      }
   }

   const handleCPToggle = () => {
      if (cpType === 'password') {
         setCPIcon(eye);
         setCPType('text')
      } else {
         setCPIcon(eyeOff)
         setCPType('password')
      }
   }

   async function enterKeyPressed(event) {
      if (event.keyCode === 13) {
         event.preventDefault();
      }
   }

   const handleSubmit = () => {
      if (!studentId) {
         addToast("This invitation link is missing a student reference. Please use the link from your invitation email.", { appearance: 'error' });
      } else if (firstName == '') {
         addToast("Enter First Name!", { appearance: 'error' });
      } else if (lastName == '') {
         addToast("Enter Last Name!", { appearance: 'error' });
      } else if (!email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
         addToast("Enter valid email!", { appearance: 'error' });
      } else if (password == '') {
         addToast("Enter Password!", { appearance: 'error' });
      } else if (password != confirmPass) {
         addToast("Password did not match!", { appearance: 'error' });
      } else {
         registerParent();
      }
   }

   async function registerParent() {
      setIsSubmitting(true);
      try {
         const res = await apiHandler(REGISTER_PARENT, "POST", {
            first_name: firstName,
            last_name: lastName,
            email: email,
            password: password,
            password_confirmation: confirmPass,
            student_id: studentId,
            token: token,
         });

         if (res.status === 200 || res.status === 201) {
            await Swal.fire({
               title: 'Registration Successful',
               text: 'Your parent account has been created. Please log in to continue.',
               icon: 'success',
               confirmButtonText: 'Go to Login'
            });
            navigate('/auth/sign-in');
         } else {
            Swal.fire({
               title: 'Registration Failed',
               text: res?.response?.data?.data?.message || 'Please try again.',
               icon: 'error',
               confirmButtonText: 'Okay'
            });
         }
      } catch (error) {
         console.error(error);
         Swal.fire({
            title: 'Registration Failed',
            text: 'A network or server error occurred. Please retry.',
            icon: 'error',
            confirmButtonText: 'Okay'
         });
      } finally {
         setIsSubmitting(false);
      }
   }

   const handleLinkSubmit = () => {
      if (!studentId) {
         addToast("This invitation link is missing a student reference. Please use the link from your invitation email.", { appearance: 'error' });
      } else if (linkPassword == '') {
         addToast("Enter Password!", { appearance: 'error' });
      } else {
         linkParentAccount();
      }
   }

   async function linkParentAccount() {
      setIsLinking(true);
      try {
         const res = await apiHandler(REGISTER_PARENT, "POST", {
            email: email,
            password: linkPassword,
            student_id: studentId,
            token: token,
         });

         if (res.status === 200 || res.status === 201) {
            await Swal.fire({
               title: 'Success',
               text: 'Your child has been linked to your parent account. Please log in to continue.',
               icon: 'success',
               confirmButtonText: 'Go to Login'
            });
            navigate('/auth/sign-in');
         } else {
            Swal.fire({
               title: 'Verification Failed',
               text: res?.response?.data?.data?.message || 'Incorrect password. Please try again.',
               icon: 'error',
               confirmButtonText: 'Okay'
            });
         }
      } catch (error) {
         console.error(error);
         Swal.fire({
            title: 'Verification Failed',
            text: 'A network or server error occurred. Please retry.',
            icon: 'error',
            confirmButtonText: 'Okay'
         });
      } finally {
         setIsLinking(false);
      }
   }

   return (
      <>
         <ToastProvider>
            <section
               className="sign-in-page auth-fullscreen-page"
               style={{ background: `linear-gradient(rgba(20, 35, 66, 0.48), rgba(20, 35, 66, 0.48)), url("${authBackground}") center / cover no-repeat` }}
            >
               <div id="container-inside">
                  <div id="circle-small"></div>
                  <div id="circle-medium"></div>
                  <div id="circle-large"></div>
                  <div id="circle-xlarge"></div>
                  <div id="circle-xxlarge"></div>
               </div>
               <Link to="/" className="auth-home-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" /></svg>
                  Home
               </Link>
               <Container className="p-0 auth-fullscreen-container" style={{ overflowY: "auto", overflowX: "hidden" }}>
                  <Row className="no-gutters auth-page-row">
                     <Col md="6" className="auth-form-col bg-white pt-5 pt-5 pb-lg-0 pb-5">
                        <div className="sign-in-from">
                           <Link className="sign-form-logo" to="/">
                              <Image src={logo} className="img-fluid" alt="logo" />
                           </Link>
                           <h1 className="mb-0">Parent Sign Up</h1>
                           <p>
                              {isParentRegistered
                                 ? "Enter your account password to link your child to your parent account."
                                 : "Create your parent account to view your child's profile"}
                           </p>
                           {!isParentRegistered && (
                           <Form className="mt-4">
                              <Row>
                                 <Col md="6" className="mb-1">
                                    <Form.Group className="form-group">
                                       <Form.Label>First name *</Form.Label>
                                       <Form.Control type="text" onKeyDown={enterKeyPressed} className="mb-0" placeholder="First name"
                                          value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                    </Form.Group>
                                 </Col>
                                 <Col md="6" className="mb-1">
                                    <Form.Group className="form-group">
                                       <Form.Label>Last name *</Form.Label>
                                       <Form.Control type="text" onKeyDown={enterKeyPressed} className="mb-0" placeholder="Last name"
                                          value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                    </Form.Group>
                                 </Col>
                                 <Col md="12" className="mb-1">
                                    <Form.Group className="form-group">
                                       <Form.Label>Email Address *</Form.Label>
                                       <Form.Control type="email" onKeyDown={enterKeyPressed} className="mb-0" placeholder="Email address"
                                          value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </Form.Group>
                                 </Col>
                                 <Col md="6" className="mb-1">
                                    <Form.Group className="form-group">
                                       <Form.Label>Password *</Form.Label>
                                       <div style={{ position: "relative", marginBottom: 60, display: "flex", justifyContent: "end" }}>
                                          <Form.Control type={pType} onKeyDown={enterKeyPressed} style={{ position: "absolute", paddingRight: 40 }} className="mb-0 d-inline-block" placeholder="Password"
                                             value={password} onChange={(e) => { setPassword(e.target.value) }} />
                                          <Icon style={{ position: "absolute", marginTop: 7, marginRight: 8 }} icon={pIcon} size={20} onClick={handlePToggle} />
                                       </div>
                                    </Form.Group>
                                 </Col>
                                 <Col md="6" className="mb-1">
                                    <Form.Group className="form-group">
                                       <Form.Label>Confirm Password *</Form.Label>
                                       <div style={{ position: "relative", marginBottom: 65, display: "flex", justifyContent: "end" }}>
                                          <Form.Control type={cpType} onKeyDown={enterKeyPressed} style={{ position: "absolute", paddingRight: 40 }} className="mb-0 d-inline-block" placeholder="Confirm password"
                                             value={confirmPass} onChange={(e) => { setConfirmPass(e.target.value) }} />
                                          <Icon style={{ position: "absolute", marginTop: 7, marginRight: 8 }} icon={cpIcon} size={20} onClick={handleCPToggle} />
                                       </div>
                                    </Form.Group>
                                 </Col>
                              </Row>
                              <div className="d-inline-block w-100">
                                 <Button type="button" className="btn-primary float-end" disabled={isSubmitting} onClick={() => handleSubmit()}>
                                    {isSubmitting ? 'Registering...' : 'Register'}
                                 </Button>
                              </div>
                              <div className="sign-info">
                                 <span className="dark-color d-inline-block line-height-2">Already Have Account ? <Link to="/auth/sign-in">Log In</Link></span>
                              </div>
                           </Form>
                           )}
                        </div>
                     </Col>
                  </Row>
               </Container>
            </section>

            <Modal show={isParentRegistered} centered backdrop="static" keyboard={false}>
               <Modal.Header>
                  <Modal.Title>Confirm Parent Account</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                  <Form.Group className="form-group mb-3">
                     <Form.Label>Email Address</Form.Label>
                     <Form.Control type="email" className="mb-0" value={email} readOnly disabled />
                  </Form.Group>
                  <Form.Group className="form-group">
                     <Form.Label>Password *</Form.Label>
                     <div style={{ position: "relative", marginBottom: 10, display: "flex", justifyContent: "end" }}>
                        <Form.Control type={linkPType} onKeyDown={enterKeyPressed} style={{ position: "absolute", paddingRight: 40 }} className="mb-0 d-inline-block" placeholder="Password"
                           value={linkPassword} onChange={(e) => { setLinkPassword(e.target.value) }} />
                        <Icon style={{ position: "absolute", marginTop: 7, marginRight: 8 }} icon={linkPIcon} size={20} onClick={handleLinkPToggle} />
                     </div>
                  </Form.Group>
               </Modal.Body>
               <Modal.Footer>
                  <Button type="button" className="btn-primary" disabled={isLinking} onClick={() => handleLinkSubmit()}>
                     {isLinking ? 'Verifying...' : 'Confirm'}
                  </Button>
               </Modal.Footer>
            </Modal>
         </ToastProvider>
      </>
   );
}

export default ParentSignUp
